import { render, staticRenderFns } from "./NeedNei.vue?vue&type=template&id=6bcabe56&scoped=true"
import script from "./NeedNei.vue?vue&type=script&lang=js"
export * from "./NeedNei.vue?vue&type=script&lang=js"
import style0 from "./NeedNei.vue?vue&type=style&index=0&id=6bcabe56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcabe56",
  null
  
)

export default component.exports